/* tslint:disable:max-classes-per-file */
import { Action } from '@ngrx/store';

export const POLL = 'POLL';

export class PollAction implements Action {
  public readonly type = POLL;
}

export type Actions = PollAction;
